document.addEventListener("DOMContentLoaded", function () {
	const clickableLabel = document.querySelector(".clickable-label");
	const discountCodeField = document.querySelector(".discount-code-field");
	const toggleIcon = document.getElementById("toggle-icon");

	if (clickableLabel) {
		clickableLabel.addEventListener("click", function (event) {
			event.preventDefault();

			const displayStyle = window.getComputedStyle(discountCodeField).display;

			if (displayStyle === "none" || displayStyle === "") {
				discountCodeField.style.display = "block";
				toggleIcon.style.transform = "rotate(180deg)";
			} else {
				discountCodeField.style.display = "none";
				toggleIcon.style.transform = "rotate(0deg)";
			}
		});
	}
});
